import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getImage } from "../../utils/cloudinarySizing";

const JobCard = ({ job }) => {

    const navigate = useNavigate();
    const [jobImageBroken, setJobImageBroken] = useState(false);

    const handleJobClick = () => {
        navigate(`/service-requests/${job.id}`);
    };

    const jobImage =
        job.images && job.images.length > 0 && job.images[0].image
            ? getImage(job.images[0].image, "srv_sm")
            : null;

    const profilePhoto = getImage(job.profile?.photo_original, "avatar_sm") || "/servspace-default-150x150.png";

    // Lead status (accepted / pending)
    const showContactInfo = job.lead_status === "accepted";

    // Format phone number (xxx) xxx-xxxx
    const formatPhone = (num) => {
        if (!num) return "";
        const cleaned = num.replace(/\D/g, "");
        if (cleaned.length !== 10) return num;
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    };

    const phoneDisplay = showContactInfo ? formatPhone(job.profile?.phone_number) : "";

    const leadStatusText = job.lead_status
        ? job.lead_status.charAt(0).toUpperCase() + job.lead_status.slice(1)
        : ""; // fallback for liked jobs

    return (
        <div className="job-card" onClick={handleJobClick}>
            {/* Left: Image */}
            <div className="job-card-image">
                {jobImage && !jobImageBroken ? (
                    <img
                        src={jobImage}
                        alt={job.title}
                        onError={() => setJobImageBroken(true)}
                    />
                ) : (
                    <div className="job-image-placeholder">
                        <span>No Image</span>
                    </div>
                )}
            </div>

            {/* Center: Job Info */}
            <div className="job-card-info">

                {/* ROW 1: Title + job.visibility/status */}
                <div className="job-dashboard-title-row">
                    <h4 className="job-title-text">
                        {job.title}
                    </h4>

                    <span className={`job-status-badge ${job.job_status}`}>
                        {job.job_status === "completed" ? "Closed" : "Active"}
                    </span>
                </div>

                {/* ROW 2: Lead status (accepted, pending, etc.) */}
                <p>
                    <strong className={`lead-status ${job.lead_status || "none"}`}>
                        {leadStatusText}
                    </strong>
                </p>
            </div>

            {/* Right: Profile Info */}
            <div className="job-card-profile">
                <div className="profile-info">
                    <p>{job.profile?.first_name}</p>
                    <p>{showContactInfo ? job.profile?.email : ""}</p>
                    <p>{phoneDisplay}</p>
                </div>
                <img
                    className="profile-pic"
                    src={profilePhoto}
                    alt={job.username}
                    onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = "/servspace-default-150x150.png";
                    }}
                />
            </div>
        </div>
    );
};

export default JobCard;
